import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Empty,
  Form,
  Image,
  Modal,
  Radio,
  Tag,
  Tooltip,
} from 'antd';
import { debounce, filter, forEach, isEmpty, map, toInteger } from 'lodash';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Countdown from 'react-countdown';
import { useHistory, useLocation } from 'react-router-dom';
import MappedUnitsCell from '../../../../../components/MappedUnitsCell';
import { AppContext } from '../../../../../AppContext';
import { ReactComponent as CommentIcon } from '../../../../../assets/svg/comment-dots-solid.svg';
import { ReactComponent as InfoIcon } from '../../../../../assets/svg/info-solid.svg';
import { ReactComponent as LocationIcon } from '../../../../../assets/svg/location-dot-solid.svg';
import { ReactComponent as FilterIcon } from '../../../../../assets/svg/sliders-solid.svg';
import { ReactComponent as TruckIcon } from '../../../../../assets/svg/purple_truck.svg';
import ORDER_TAG_BULK_ACTIONS, {
  BREACH_TIME_CRITICAL_THRESHOLD,
  BREACH_TIME_WARNING_THRESHOLD,
  COMMENT_ORDER_PHASE,
  COMMENT_TARGET_TYPE,
  CRITICAL_ORDERS_KEY,
  DATE_FORMATS,
  DELIVERY_CONFIRMATION_TYPE,
  DELIVERY_TYPE,
  DELIVERY_TYPE_OPTIONS,
  ORDER_TYPE_FILTER_OPTIONS,
  EXPRESS_DELIVERY_EMOJI,
  EXPRESS_DELIVERY_TOOLTIP_TEXT,
  FULFILLMENT_STATUS,
  LIMIT,
  ORDERS_POLLING_INTERVAL,
  ORDER_STATUS,
  ORDER_TAG_TYPES,
  ORDER_TYPE,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  QUICK_DELIVERY_EMOJI,
  QUICK_DELIVERY_TOOLTIP_TEXT,
  ROUTES,
  SORT,
  SORTING,
  STOCK_COLUMN_TOOLTIPS,
  TABLE_FILTER_KEYS,
  USER_ROLES,
} from '../../../../../common/constants';
import {
  formatDate,
  getAttachmentSource,
  getRowClassName,
  handleOpenUserDrawer,
  hasNonEmptyValueObj,
  hasPermission,
  hasPreOrderToy,
  isSalesUser,
  renderer,
  toDayjsRange,
  humanizeEnum,
} from '../../../../../common/utils';
import ChallanDownloadButton from '../../../../../components/ChallanDownloadButton';
import ColumnTitleWithInfo from '../../../../../components/ColumnTitleWithInfo';
import CommonPreview from '../../../../../components/CommonPreview';
import CommonPreviewTable from '../../../../../components/CommonPreviewTable';
import CommonTable from '../../../../../components/CommonTable';
import LoaderComponent from '../../../../../components/LoaderComponent';
import BulkActionButton from '../../../../../components/BulkActionButton';
import OrderDynamicTags from '../../../../../components/OrderDynamicTags';
import SearchComponent from '../../../../../components/SearchComponent';
import SortDropdown from '../../../../../components/SortDropdown';
import useInfiniteScroll from '../../../../../hooks/useInfiniteScroll';
import useOrderAlert from '../../../../../hooks/useOrderAlert';
import AddCommentModal from '../../../../../libraryModules/orders/modules/all/components/AddCommentModal';
import AllFilterOrderModal from '../../../../../libraryModules/orders/modules/all/components/AllFilterOrderModal';
import OrderTagsFilter from '../../../../../components/OrderTagsFilter';
import AllOrderItemModal from '../../../../../libraryModules/orders/modules/all/components/AllOrderItemModal';
import AllOrderList from '../../../../../libraryModules/orders/modules/all/components/AllOrderList';
import { USERS } from '../../../../../libraryModules/raiseRequest/graphql/Queries';
import { PINCODES } from '../../../../lists/modules/pincodeMapping/graphql/Queries';
import ResolveCommentModal from '../../../../requests/modules/library/components/ResolveCommentModal';
import { LIBRARIES } from '../../../../requests/modules/library/graphql/Queries';

import { CITIES } from '../../../../../components/graphql/Queries';
import RenderCopyIcon from '../../../../../components/RenderCopyIcon';
import ShowPreOrderSwitch from '../../../../../components/ShowPreOrderSwitch';
import ShowDelayedOrdersSwitch from '../../../../../components/ShowDelayedOrdersSwitch';
import useRetainedTableState from '../../../../../hooks/useRetainedTableFilterState';
import { USER_LAT_LONG_DETAILS } from '../../../../users/graphql/Queries';
import BigToyIcon from '../../new/components/BigToyIcon';
import StatusFlag from '../../new/components/OrderTagRenderer';
import { UPDATE_ORDER_STATUS_ADMIN_V2 } from '../../new/graphql/Mutations';
import {
  CANCEL_ORDER_ADMIN,
  CREATE_COMMENT,
  RESET_ORDER_CHALLAN_ADMIN,
  RESET_ORDER_ITEM_STICKER_ADMIN,
} from '../graphql/Mutations';
import {
  GET_ORDER_CHALLAN_DOWNLOAD_URL_ADMIN,
  GET_ORDER_STICKER_DOWNLOAD_URL_ADMIN,
  ORDERS_ADMIN,
  ORDERS_SELECT,
  ORDER_ITEMS_ADMIN,
} from '../graphql/Queries';
import ContentMasterModal from './ContentMasterModal';
import DelayReasonModal from './DelayReasonModal';
import ItemStatusModal from './ItemStatusModal';
import NoteModal from './NoteModal';
import RiderLocationModal from './RiderLocationModal';
import TrackOrderIframeModal from '../../../../../components/TrackOrderIframeModal';
import useToyDrawer from '../../../../../hooks/useToyDrawer';
import createOrderItemStaffColumns from '../../../../../components/OrderItemStaff/createOrderItemStaffColumns';
import { isUnitsFeatureEnabledForLibrary } from '../../../../../hooks/useInventoryUnitsFeature';

const { RangePicker } = DatePicker;
const { Group } = Radio;

const initialPaginationValue = {
  total: 0,
  current: 1,
  pageSize: 10,
};

const initialNewDeliveryFilter = {
  limit: LIMIT,
  search: '',
  skip: 0,
};

const initialNewDeliverySort = {
  field: 'createdAt',
  order: 'DESC',
};

const initialTableFilter = {
  skip: 0,
  limit: LIMIT,
  search: '',
};

const initialTableSort = {
  field: 'createdAt',
  order: 'DESC',
};
const sort = [
  {
    label: SORTING?.ORDER_ID_A_Z?.label,
    value: SORTING?.ORDER_ID_A_Z?.value,
    field: SORTING?.ORDER_ID_A_Z?.field,
    sort: SORTING?.ORDER_ID_A_Z?.sort,
  },
  {
    label: SORTING?.ORDER_ID_Z_A?.label,
    value: SORTING?.ORDER_ID_Z_A?.value,
    field: SORTING?.ORDER_ID_Z_A?.field,
    sort: SORTING?.ORDER_ID_Z_A?.sort,
  },
  {
    label: SORTING?.TOTAL_ORDERS_COUNT_A_Z?.label,
    value: SORTING?.TOTAL_ORDERS_COUNT_A_Z?.value,
    field: SORTING?.TOTAL_ORDERS_COUNT_A_Z?.field,
    sort: SORTING?.TOTAL_ORDERS_COUNT_A_Z?.sort,
  },
  {
    label: SORTING?.TOTAL_ORDERS_COUNT_Z_A?.label,
    value: SORTING?.TOTAL_ORDERS_COUNT_Z_A?.value,
    field: SORTING?.TOTAL_ORDERS_COUNT_Z_A?.field,
    sort: SORTING?.TOTAL_ORDERS_COUNT_Z_A?.sort,
  },
];
let filterScrollDebounceJob = null;

const AllDeliveryTable = ({
  exportFilter,
  setExportFilter,
  setSelectedOrders,
  selectedOrders,
  setDownloadableSelectedOrders,
}) => {
  const {
    dispatch,
    state: {
      isDesktop,
      permissions,
      currentUser,
      commonPermissions: {
        isUserPermission,
        isToyPermission,
        isDeliveryPartnerPermission,
        isLibraryPermission,
      },
    },
  } = useContext(AppContext);
  const history = useHistory();
  const { openToyDrawer } = useToyDrawer();
  const [form] = Form.useForm();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const user = useRef(queryParams?.get('user') || '');
  const [orderList, setOrderList] = useState([]);

  const downloadableStatuses = [
    ORDER_STATUS?.READY_TO_SHIP?.value,
    ORDER_STATUS?.SHIPPED?.value,
    ORDER_STATUS?.CONFIRMED?.value,
    ORDER_STATUS?.DELIVERED?.value,
    ORDER_STATUS?.NOT_DELIVERED?.value,
  ];

  const downloadableSelectedOrders = useMemo(() => {
    const ids = selectedOrders || [];
    return ids.filter((id) => {
      const record = (orderList || []).find((o) => o?.id === id);
      return downloadableStatuses.includes(record?.status);
    });
  }, [orderList, selectedOrders]);

  useEffect(() => {
    if (typeof setDownloadableSelectedOrders !== 'function') return;
    setDownloadableSelectedOrders(downloadableSelectedOrders);
  }, [setDownloadableSelectedOrders, downloadableSelectedOrders]);

  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [isEmptyOrderList, setIsEmptyOrderList] = useState(false);
  const [order, setOrder] = useState({});
  const [orderItem, setOrderItem] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [paginationProp, setPaginationProp] = useState(initialPaginationValue);

  const [isOrderLoading, setIsOrderLoading] = useState(true);
  const [isNotePrompts, setIsNotePrompts] = useState(false);
  const [isReasonPrompt, setIsReasonPrompt] = useState(false);
  const [isOrderAction, setIsOrderAction] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [nestedData, setNestedData] = useState({});
  const [isLoading, setIsLoading] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [isChallanLoading, setIsChallanLoading] = useState({});
  const [isResetLoading, setIsResetLoading] = useState({});
  const [isStickerLoading, setIsStickerLoading] = useState({});
  const [isResetStickerLoading, setIsResetStickerLoading] = useState({});
  const [isCommentPrompts, setIsCommentPrompts] = useState(false);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
  const [isAddCommentLoading, setIsAddCommentLoading] = useState(false);

  const [filterSearch, setFilterSearch] = useState('');
  const [filterList, setFilterList] = useState([]);
  const [whereFilter, setWhereFilter] = useState();
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterTags, setFilterTags] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterIndex, setFilterIndex] = useState(null);
  const [finalWhereFilters, setFinalWhereFilters] = useState();
  const [finalFilterTags, setFinalFilterTags] = useState(null);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const selectedTagIdsRef = useRef([]);
  const [filterIsEnd, setFilterIsEnd] = useState(false);
  const [isEmptyFilterList, setIsEmptyFilterList] = useState(false);
  const [visible, setVisible] = useState(false);
  const [toyImages, setToyImages] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [toyPreviewImage, setToyPreviewImage] = useState();
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] = useState(false);
  const [isContentMasterModalOpen, setIsContentMasterModalOpen] = useState(
    false,
  );
  const finalWhereFiltersRef = useRef(null);
  const paginationPropRef = useRef(initialPaginationValue);
  const orderSearchTermRef = useRef(orderSearchTerm);
  const [thresholdData, setThresholdData] = useState({});
  const sortedInfoRef = useRef(null);

  const { playNotificationSound } = useOrderAlert();
  const criticalOrdersRef = useRef(new Set());
  const isPollingRef = useRef(false);
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false);
  const [trackingUrl, setTrackingUrl] = useState('');
  const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [refreshIntervalId, setRefreshIntervalId] = useState(null);
  const {
    retainedState,
    saveRetainedFilterState,
    hydrated,
  } = useRetainedTableState();

  const [initializedFromRetained, setInitializedFromRetained] = useState(false);

  useEffect(() => {
    if (!hydrated) return; // wait for URL hydration
    if (initializedFromRetained) return; // run only once

    const retainedFilters = retainedState?.[TABLE_FILTER_KEYS.ALL_DELIVERY];
    if (!retainedFilters) {
      setInitializedFromRetained(true);
      return;
    }
    const baseFilters = retainedFilters?.filters || {};
    const normalizedFilters = {
      ...baseFilters,
      createdAt: toDayjsRange(baseFilters?.createdAt),
      deliveredOn: toDayjsRange(baseFilters?.deliveredOn),
    };
    setFinalWhereFilters(normalizedFilters);
    finalWhereFiltersRef.current = normalizedFilters;

    setFilterTags(retainedFilters?.filterTags || {});
    setFinalFilterTags(retainedFilters?.filterTags || {});
    setSortedInfo(retainedFilters.sort || {});
    sortedInfoRef.current = retainedFilters.sort || {};

    setPaginationProp(retainedFilters.paginationProp || initialPaginationValue);
    paginationPropRef.current =
      retainedFilters.paginationProp || initialPaginationValue;

    setOrderSearchTerm(retainedFilters.searchTerm || '');
    orderSearchTermRef.current = retainedFilters.searchTerm || '';

    setInitializedFromRetained(true);
  }, [hydrated, initializedFromRetained, retainedState]);

  const [USERS_LAT_LONG_DETAILS] = useLazyQuery(USER_LAT_LONG_DETAILS, {
    onCompleted: (response) => {
      setLatitude(response?.user?.latLong?.coordinates[1]);
      setLongitude(response?.user?.latLong?.coordinates[0]);
    },
    fetchPolicy: 'network-only',
    onError() {},
  });

  const openGoogleMaps = (lat, lng, userid) => {
    setIsLocationModalVisible(true);
    setLatitude(lat);
    setLongitude(lng);
    USERS_LAT_LONG_DETAILS({
      variables: { where: { id: userid } },
    });
    const intervalId = setInterval(() => {
      USERS_LAT_LONG_DETAILS({
        variables: { where: { id: userid } },
      });
    }, 30000);

    setRefreshIntervalId(intervalId);
  };
  useEffect(() => {
    if (!isLocationModalVisible && refreshIntervalId) {
      clearInterval(refreshIntervalId);
      setRefreshIntervalId(null);
    }
  }, [isLocationModalVisible, refreshIntervalId]);

  useEffect(
    () => () => {
      if (refreshIntervalId) {
        clearInterval(refreshIntervalId);
      }
    },
    [],
  );
  useEffect(() => {
    // eslint-disable-next-line no-undef
    const stored = localStorage.getItem(CRITICAL_ORDERS_KEY);
    if (stored) {
      try {
        criticalOrdersRef.current = new Set(JSON.parse(stored));
      } catch (error) {
        criticalOrdersRef.current = new Set();
      }
    }
  }, []);

  const [isActive, setIsActive] = useState(true);

  const [isAllFilterModalOpen, setIsAllFilterModalOpen] = useState(false);
  const [isAllOrderItemModalOpen, setIsAllOrderItemModalOpen] = useState(false);
  const [isAllSortPopoverOpen, setIsAllSortPopoverOpen] = useState(false);
  const [isFetchMoreOrderLoading, setIsFetchMoreOrderLoading] = useState(false);

  const [ordersAdmin] = useLazyQuery(ORDERS_ADMIN, {
    onCompleted: (response) => {
      if (isDesktop) {
        setOrderList([...response?.ordersAdmin?.data]);
      } else {
        const newOrders = response?.ordersAdmin?.data || [];
        const existingIds = new Set(
          orderList?.map((currentOrder) => currentOrder?.orderNumber),
        );
        const uniqueNewOrders = newOrders?.filter(
          (currentOrder) => !existingIds?.has(currentOrder.orderNumber),
        );

        if (isPollingRef?.current) {
          setOrderList([...uniqueNewOrders, ...orderList]);
          isPollingRef.current = false;
        } else {
          setOrderList([...orderList, ...uniqueNewOrders]);
        }
      }

      const criticalThreshold = toInteger(
        response?.ordersAdmin?.configs?.find(
          (config) => config?.key === BREACH_TIME_CRITICAL_THRESHOLD,
        )?.value,
      );
      const warningThreshold = toInteger(
        response?.ordersAdmin?.configs?.find(
          (config) => config?.key === BREACH_TIME_WARNING_THRESHOLD,
        )?.value,
      );

      setThresholdData({
        criticalThreshold,
        warningThreshold,
      });
      if (
        response?.ordersAdmin?.count === 0 &&
        initialPaginationValue?.total === 0
      ) {
        setIsEmptyOrderList(true);
      } else {
        setIsEmptyOrderList(false);
      }
      if (response?.ordersAdmin?.data?.length < LIMIT) {
        setIsActive(false);
      }

      const pagination = {
        ...paginationProp,
        defaultPageSize: LIMIT,
        total: response?.ordersAdmin?.count,
      };
      setPaginationProp(pagination);
      paginationPropRef.current = pagination;

      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
        paginationProp: pagination,
      });
      setIsFetchMoreOrderLoading(false);
      setIsOrderLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {},
  });

  const handleSort = (values) => {
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      current: 1,
      skip: 0,
    };
    setIsOrderLoading(true);
    setIsAllSortPopoverOpen(false);
    setIsActive(true);
    setOrderList([]);
    const filteredSort = sort?.filter((item) => item?.value === values?.sort);
    if (filteredSort?.[0]?.field) {
      setSortedInfo({
        ...sortedInfo,
        field: filteredSort?.[0]?.field,
        columnKey: filteredSort?.[0]?.field,
        order: filteredSort?.[0]?.sort === SORT?.ASC ? 'ascend' : 'descend',
        column: filteredSort?.[0]?.field,
      });
      sortedInfoRef.current = {
        ...sortedInfoRef?.current,
        field: filteredSort?.[0]?.field,
        columnKey: filteredSort?.[0]?.field,
        order: filteredSort?.[0]?.sort === SORT?.ASC ? 'ascend' : 'descend',
        column: filteredSort?.[0]?.field,
      };
    }

    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      sort: {
        ...sortedInfo,
        field: filteredSort?.[0]?.field,
        columnKey: filteredSort?.[0]?.field,
        order: filteredSort?.[0]?.sort === SORT?.ASC ? 'ascend' : 'descend',
        column: filteredSort?.[0]?.field,
      },
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          limit: paginationProp?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.NEW,
          orderIds: finalWhereFilters?.orderNumber,
          search: orderSearchTerm,
          deliveryType: finalWhereFilters?.deliveryType,
          orderTypes:
            finalWhereFilters?.orderTypes?.length > 0
              ? finalWhereFilters?.orderTypes
              : undefined,
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : undefined,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: finalWhereFilters?.deliveredOn?.from?.$d,
            to: finalWhereFilters?.deliveredOn?.to?.$d,
          },
          ...(finalWhereFilters?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                  to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          pincodeIds: finalWhereFilters?.pincodes,
          city: finalWhereFilters?.city,
          libraryIds: finalWhereFilters?.libraryId,
          deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
        },
        sort: filteredSort?.[0]
          ? {
              field: filteredSort?.[0]?.field,
              order: filteredSort?.[0]?.sort,
            }
          : initialNewDeliverySort,
      },
    });
  };

  const [orderItemsAdmin] = useLazyQuery(ORDER_ITEMS_ADMIN, {
    fetchPolicy: 'no-cache',
    onError() {},
  });

  const handleTagFilterChange = (tagIds) => {
    selectedTagIdsRef.current = tagIds;
    setSelectedTagIds(tagIds);
    setIsOrderLoading(true);
    setOrderList([]);
    setIsActive(true);
    setNestedData({});
    setExpandedRowKeys([]);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    paginationPropRef.current = {
      ...paginationPropRef.current,
      current: 1,
      skip: 0,
    };
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          limit: paginationProp?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.ALL,
          orderIds: finalWhereFiltersRef?.current?.orderNumber,
          search: orderSearchTermRef?.current,
          deliveryType: finalWhereFiltersRef?.current?.deliveryType,
          orderTypes:
            finalWhereFiltersRef?.current?.orderTypes?.length > 0
              ? finalWhereFiltersRef?.current?.orderTypes
              : undefined,
          status:
            finalWhereFiltersRef?.current?.status?.length > 0
              ? finalWhereFiltersRef?.current?.status
              : undefined,
          dateRange: {
            from: finalWhereFiltersRef?.current?.createdAt?.from?.$d,
            to: finalWhereFiltersRef?.current?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: finalWhereFiltersRef?.current?.deliveredOn?.from?.$d,
            to: finalWhereFiltersRef?.current?.deliveredOn?.to?.$d,
          },
          ...(finalWhereFiltersRef?.current?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from:
                    finalWhereFiltersRef?.current?.expectedDeliveryDate?.from
                      ?.$d,
                  to:
                    finalWhereFiltersRef?.current?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          pincodeIds: finalWhereFiltersRef?.current?.pincodes,
          statusTiming: finalWhereFiltersRef?.current?.statusTiming,
          city: finalWhereFiltersRef?.current?.city,
          libraryIds: finalWhereFiltersRef?.current?.name,
          deliveryPartnerIds:
            finalWhereFiltersRef?.current?.deliveryPartnerName,
          isPreOrder: finalWhereFiltersRef?.current?.isPreOrder,
          isDelayed: finalWhereFiltersRef?.current?.isDelayed,
          orderTagIds: tagIds?.length > 0 ? tagIds : undefined,
        },
        sort: sortedInfoRef?.current?.column
          ? {
              field: sortedInfoRef?.current?.field,
              order:
                sortedInfoRef?.current?.order === 'ascend'
                  ? SORT?.ASC
                  : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
  };

  const handleOrderScroll = () => {
    if (!isFetchMoreOrderLoading && !isOrderLoading) {
      isPollingRef.current = false;
      const currentLength = orderList?.length;

      setIsFetchMoreOrderLoading(true);
      ordersAdmin({
        variables: {
          filter: {
            ...initialNewDeliveryFilter,
            skip: currentLength,
            limit: paginationProp?.pageSize || LIMIT,
            orderType: ORDER_TYPE?.NEW,
            orderIds: finalWhereFilters?.orderNumber,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            orderTypes:
              finalWhereFilters?.orderTypes?.length > 0
                ? finalWhereFilters?.orderTypes
                : undefined,
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : undefined,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            deliveredOn: {
              from: finalWhereFilters?.deliveredOn?.from?.$d,
              to: finalWhereFilters?.deliveredOn?.to?.$d,
            },
            ...(finalWhereFilters?.expectedDeliveryDate?.from
              ? {
                  expectedDeliveryDate: {
                    from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                    to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                  },
                }
              : {}),
            pincodeIds: finalWhereFilters?.pincodes,
            libraryIds: finalWhereFilters?.name,
            city: finalWhereFilters?.city,
            isPreOrder: finalWhereFilters?.isPreOrder,
            isDelayed: finalWhereFilters?.isDelayed,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialNewDeliverySort,
        },
      });
    }
  };

  const mobileConfig = {};

  const infiniteScrollRef = useInfiniteScroll(handleOrderScroll, isActive);

  const handleFilter = (values) => {
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      current: 1,
      skip: 0,
    };
    setIsOrderLoading(true);
    setIsAllFilterModalOpen(false);
    setOrderList([]);
    setIsActive(true);
    const filters = {
      status: values?.status,
      createdAt: values?.createdAt?.[1]
        ? { from: values?.createdAt?.[0], to: values?.createdAt?.[1] }
        : null,
      deliveredOn: values?.deliveredOn?.[1]
        ? { from: values?.deliveredOn?.[0], to: values?.deliveredOn?.[1] }
        : null,
      pincodes: values?.pincodes,
      deliveryType: values?.deliveryType,
      orderTypes: values?.orderTypes,
      name: values?.name,
      city: values?.city,
    };
    setWhereFilter(filters);
    setFinalWhereFilters(filters);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      filters,
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });
    finalWhereFiltersRef.current = filters;
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          limit: paginationProp?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.NEW,
          search: orderSearchTerm,
          deliveryType: values?.deliveryType,
          orderTypes:
            values?.orderTypes?.length > 0 ? values?.orderTypes : undefined,
          status: values?.status?.length > 0 ? values?.status : undefined,
          dateRange: {
            from: values?.createdAt?.[0],
            to: values?.createdAt?.[1],
          },
          deliveredOn: {
            from: values?.deliveredOn?.[0],
            to: values?.deliveredOn?.[1],
          },
          pincodeIds: values?.pincodes,
          city: values?.city,
          libraryIds: values?.name,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
  };

  const handleSelectAllMobile = (checked) => {
    if (checked) {
      setSelectedOrders((prev) => {
        const newIds = (orderList || [])?.map((data) => data?.id);
        return Array.from(new Set([...prev, ...newIds]));
      });
    } else {
      setSelectedOrders([]);
    }
  };

  const handleSelectOrders = (key) => {
    setSelectedOrders((prev) => {
      if (prev?.includes(key)) {
        return prev?.filter((item) => item !== key);
      }
      return [...prev, key];
    });
  };

  const findSelectableOrders = () => orderList || [];

  const [cancelOrderAdmin] = useMutation(CANCEL_ORDER_ADMIN, {
    onError: () => {},
  });

  const [getOrderChallanDownloadUrlAdmin] = useLazyQuery(
    GET_ORDER_CHALLAN_DOWNLOAD_URL_ADMIN,
    {
      fetchPolicy: 'network-only',
      onError() {},
    },
  );

  const [getOrderStickerDownloadUrlAdmin] = useLazyQuery(
    GET_ORDER_STICKER_DOWNLOAD_URL_ADMIN,
    {
      fetchPolicy: 'network-only',
      onError() {},
    },
  );

  const [users, { loading: isUsersLoading }] = useLazyQuery(USERS, {
    onCompleted: (response) => {
      if (response?.users?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.users?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.users?.data, (item) =>
        optionsCopy?.push({
          label: `${
            item?.firstName || item?.lastName
              ? `${item?.firstName || ''} ${item?.lastName || ''}`
              : '-'
          }`,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [pincodes, { loading: isPincodesLoading }] = useLazyQuery(PINCODES, {
    onCompleted: (response) => {
      if (response?.pincodes?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.pincodes?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.pincodes?.data, (item) =>
        optionsCopy?.push({
          label: item?.pincode,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [libraries, { loading: isLibrariesLoading }] = useLazyQuery(LIBRARIES, {
    onCompleted: (response) => {
      if (response?.libraries?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.libraries?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.libraries?.data, (item) =>
        optionsCopy?.push({ label: item?.name, key: item?.id }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [cities, { loading: isCityLoading }] = useLazyQuery(CITIES, {
    onCompleted: (response) => {
      if (response?.cities?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.cities?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.cities?.data, (item) =>
        optionsCopy?.push({ label: item?.name, key: item?.name }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [orderSelect, { loading: isOrderSelectLoading }] = useLazyQuery(
    ORDERS_SELECT,
    {
      onCompleted: (response) => {
        if (response?.ordersAdmin?.data?.length < LIMIT) {
          setFilterIsEnd(true);
        }
        if (response?.ordersAdmin?.count === 0) {
          setIsEmptyFilterList(true);
        } else {
          setIsEmptyFilterList(false);
        }
        const optionsCopy = [];
        forEach(response?.ordersAdmin?.data, (item) =>
          optionsCopy?.push({
            label: item?.orderNumber,
            key: item?.id,
          }),
        );
        setFilterList([...filterList, ...optionsCopy]);
        setFilterLoading(false);
      },
      fetchPolicy: 'network-only',
      onError() {
        setFilterLoading(false);
      },
    },
  );

  const [createComment] = useMutation(CREATE_COMMENT, {
    onError: () => {},
  });

  const [resetOrderChallanAdmin] = useMutation(RESET_ORDER_CHALLAN_ADMIN, {
    onError: () => {},
  });

  const [resetOrderItemStickerAdmin] = useMutation(
    RESET_ORDER_ITEM_STICKER_ADMIN,
    {
      onError: () => {},
    },
  );

  const hasUpdatePermission = hasPermission(
    PERMISSIONS_KEY?.ORDERS_ALL_DELIVERY,
    PERMISSION_TYPE?.UPDATE,
    permissions,
  );
  const getStaffColumns = createOrderItemStaffColumns({ canEdit: false });

  const fetchOrders = () => {
    if (!hydrated || !initializedFromRetained) return; // NEW

    isPollingRef.current = true;
    if (user.current) {
      setOrderSearchTerm(user?.current);
      orderSearchTermRef.current = user?.current;
    }

    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          skip:
            (paginationPropRef?.current?.current - 1) *
            (paginationPropRef?.current?.pageSize || 0),
          search: orderSearchTermRef?.current,
          limit: paginationPropRef?.current?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.ALL,
          orderIds: finalWhereFiltersRef?.current?.orderNumber,
          deliveryType: finalWhereFiltersRef?.current?.deliveryType,
          orderTypes:
            finalWhereFiltersRef?.current?.orderTypes?.length > 0
              ? finalWhereFiltersRef?.current?.orderTypes
              : undefined,
          status:
            finalWhereFiltersRef?.current?.status?.length > 0
              ? finalWhereFiltersRef?.current?.status
              : undefined,
          dateRange: {
            from: finalWhereFiltersRef?.current?.createdAt?.from?.$d,
            to: finalWhereFiltersRef?.current?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: finalWhereFiltersRef?.current?.deliveredOn?.from?.$d,
            to: finalWhereFiltersRef?.current?.deliveredOn?.to?.$d,
          },
          ...(finalWhereFiltersRef?.current?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from:
                    finalWhereFiltersRef?.current?.expectedDeliveryDate?.from
                      ?.$d,
                  to:
                    finalWhereFiltersRef?.current?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          pincodeIds: finalWhereFiltersRef?.current?.pincodes,
          statusTiming: finalWhereFiltersRef?.current?.statusTiming,
          city: finalWhereFiltersRef?.current?.city,
          libraryIds: finalWhereFiltersRef?.current?.name,
          deliveryPartnerIds:
            finalWhereFiltersRef?.current?.deliveryPartnerName,
          isPreOrder: finalWhereFiltersRef?.current?.isPreOrder,
          isDelayed: finalWhereFiltersRef?.current?.isDelayed,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfoRef?.current?.column
          ? {
              field: sortedInfoRef?.current?.field,
              order:
                sortedInfoRef?.current?.order === 'ascend'
                  ? SORT?.ASC
                  : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
  };

  useEffect(() => {
    fetchOrders();
    const intervalId = setInterval(fetchOrders, ORDERS_POLLING_INTERVAL);
    return () => clearInterval(intervalId);
  }, [hydrated, initializedFromRetained]);

  const handleTableChange = (pagination, tableFilter, sorter) => {
    const { current } = pagination;
    const skip = (current - 1) * (pagination?.pageSize || 0);
    setPaginationProp({ ...paginationProp, ...pagination });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      ...pagination,
    };
    setIsOrderLoading(true);
    setSortedInfo(sorter);
    sortedInfoRef.current = sorter;

    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      sort: sorter,
      paginationProp: { ...paginationProp, pagination },
    });
    setNestedData({});
    setExpandedRowKeys([]);
    setSelectedOrders([]);
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          skip,
          limit: pagination?.pageSize,
          orderType: ORDER_TYPE?.ALL,
          search: orderSearchTerm,
          deliveryType: finalWhereFilters?.deliveryType,
          orderTypes:
            finalWhereFilters?.orderTypes?.length > 0
              ? finalWhereFilters?.orderTypes
              : undefined,
          orderIds: finalWhereFilters?.orderNumber,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: finalWhereFilters?.deliveredOn?.from?.$d,
            to: finalWhereFilters?.deliveredOn?.to?.$d,
          },
          ...(finalWhereFilters?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                  to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : undefined,
          pincodeIds: finalWhereFilters?.pincodes,
          deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
          libraryIds: finalWhereFilters?.name,
          statusTiming: finalWhereFilters?.statusTiming,
          city: finalWhereFilters?.city,
          isPreOrder: finalWhereFilters?.isPreOrder,
          isDelayed: finalWhereFilters?.isDelayed,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sorter?.column
          ? {
              field: sorter?.field,
              order: sorter?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
  };

  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleSearch = (value) => {
    const trimValue = value?.trim();
    user.current = trimValue;
    setOrderSearchTerm(trimValue);
    orderSearchTermRef.current = trimValue;
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      current: 1,
      skip: 0,
    };

    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      searchTerm: trimValue,
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });
    setIsOrderLoading(true);
    setNestedData({});
    setExpandedRowKeys([]);
    if (!isDesktop) {
      setOrderList([]);
    }
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          limit: paginationProp?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.ALL,
          search: trimValue,
          deliveryType: finalWhereFilters?.deliveryType,
          orderTypes:
            finalWhereFilters?.orderTypes?.length > 0
              ? finalWhereFilters?.orderTypes
              : undefined,
          orderIds: finalWhereFilters?.orderNumber,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: finalWhereFilters?.deliveredOn?.from?.$d,
            to: finalWhereFilters?.deliveredOn?.to?.$d,
          },
          ...(finalWhereFilters?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                  to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : undefined,
          pincodeIds: finalWhereFilters?.pincodes,
          deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
          libraryIds: finalWhereFilters?.name,
          statusTiming: finalWhereFilters?.statusTiming,
          city: finalWhereFilters?.city,
          isPreOrder: finalWhereFilters?.isPreOrder,
          isDelayed: finalWhereFilters?.isDelayed,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
    setExportFilter({ ...exportFilter, search: trimValue });
  };

  const handleAddComment = async (values) => {
    setIsCommentLoading(true);
    const response = await createComment({
      variables: {
        data: {
          targetType: isOrderAction
            ? COMMENT_TARGET_TYPE?.ORDER
            : COMMENT_TARGET_TYPE?.ORDER_ITEM,
          targetId: isOrderAction ? order?.id : orderItem?.id,
          metaData: {
            orderPhase: isOrderAction
              ? COMMENT_ORDER_PHASE?.ORDER
              : COMMENT_ORDER_PHASE?.UNFULFILLED,
          },
          isResolved: true,
          comment: values?.comment?.trim(),
        },
      },
    });
    if (response?.data) {
      setIsOrderLoading(true);
      setIsCommentPrompts(false);
      setNestedData({});
      if (!isDesktop) {
        setOrderList([]);
      }
      setExpandedRowKeys([]);
      form?.resetFields();
      ordersAdmin({
        variables: {
          filter: {
            ...initialNewDeliveryFilter,
            skip:
              (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
            limit: paginationProp?.pageSize || LIMIT,
            orderType: ORDER_TYPE?.ALL,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            orderTypes:
              finalWhereFilters?.orderTypes?.length > 0
                ? finalWhereFilters?.orderTypes
                : undefined,
            orderIds: finalWhereFilters?.orderNumber,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            deliveredOn: {
              from: finalWhereFilters?.deliveredOn?.from?.$d,
              to: finalWhereFilters?.deliveredOn?.to?.$d,
            },
            ...(finalWhereFilters?.expectedDeliveryDate?.from
              ? {
                  expectedDeliveryDate: {
                    from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                    to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                  },
                }
              : {}),
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : undefined,
            pincodeIds: finalWhereFilters?.pincodes,
            deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
            libraryIds: finalWhereFilters?.name,
            statusTiming: finalWhereFilters?.statusTiming,
            city: finalWhereFilters?.city,
            isPreOrder: finalWhereFilters?.isPreOrder,
            isDelayed: finalWhereFilters?.isDelayed,
            orderTagIds:
              selectedTagIdsRef?.current?.length > 0
                ? selectedTagIdsRef.current
                : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialNewDeliverySort,
        },
      });
    }
    setIsCommentLoading(false);
  };

  const [updateOrderStatusAdmin] = useMutation(UPDATE_ORDER_STATUS_ADMIN_V2, {
    onError: () => {},
  });

  const [isDeliverLoading, setIsDeliverLoading] = useState(false);
  const [isDeliveredPrompt, setIsDeliveredPrompt] = useState(false);

  const handleDeliverOrder = async (values) => {
    setIsDeliverLoading(true);
    const response = await updateOrderStatusAdmin({
      variables: {
        where: {
          id: values,
        },
        data: {
          status: ORDER_STATUS?.DELIVERED?.value,
        },
      },
    });
    if (response?.data) {
      setIsOrderLoading(true);
      setIsDeliveredPrompt(false);
      setNestedData({});
      setOrderList([]);
      setExpandedRowKeys([]);
      ordersAdmin({
        variables: {
          filter: {
            ...initialNewDeliveryFilter,
            skip:
              (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
            limit: paginationProp?.pageSize || LIMIT,
            orderType: ORDER_TYPE?.ALL,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            orderTypes:
              finalWhereFilters?.orderTypes?.length > 0
                ? finalWhereFilters?.orderTypes
                : undefined,
            orderIds: finalWhereFilters?.orderNumber,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            deliveredOn: {
              from: finalWhereFilters?.deliveredOn?.from?.$d,
              to: finalWhereFilters?.deliveredOn?.to?.$d,
            },
            ...(finalWhereFilters?.expectedDeliveryDate?.from
              ? {
                  expectedDeliveryDate: {
                    from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                    to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                  },
                }
              : {}),
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : undefined,
            pincodeIds: finalWhereFilters?.pincodes,
            deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
            libraryIds: finalWhereFilters?.name,
            statusTiming: finalWhereFilters?.statusTiming,
            city: finalWhereFilters?.city,
            isPreOrder: finalWhereFilters?.isPreOrder,
            isDelayed: finalWhereFilters?.isDelayed,
            orderTagIds:
              selectedTagIdsRef?.current?.length > 0
                ? selectedTagIdsRef.current
                : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialNewDeliverySort,
        },
      });
    }
    setIsDeliverLoading(false);
    setIsDeliveredPrompt(false);
  };

  const handleAddCommentInOrder = async (values) => {
    setIsAddCommentLoading(true);
    const response = await cancelOrderAdmin({
      variables: {
        where: {
          id: order?.id,
        },
        data: {
          additionalComment: values?.comment?.trim(),
          reason: values?.reason,
        },
      },
    });
    if (response?.data) {
      setIsOrderLoading(true);
      setIsAddCommentModalOpen(false);
      setNestedData({});
      setExpandedRowKeys([]);
      form?.resetFields();
      if (isDesktop) {
        setOrderList([]);
      }
      ordersAdmin({
        variables: {
          filter: {
            ...initialNewDeliveryFilter,
            skip:
              (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
            limit: paginationProp?.pageSize || LIMIT,
            orderType: ORDER_TYPE?.ALL,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            orderTypes:
              finalWhereFilters?.orderTypes?.length > 0
                ? finalWhereFilters?.orderTypes
                : undefined,
            orderIds: finalWhereFilters?.orderNumber,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            deliveredOn: {
              from: finalWhereFilters?.deliveredOn?.from?.$d,
              to: finalWhereFilters?.deliveredOn?.to?.$d,
            },
            ...(finalWhereFilters?.expectedDeliveryDate?.from
              ? {
                  expectedDeliveryDate: {
                    from: finalWhereFilters?.expectedDeliveryDate?.from?.$d,
                    to: finalWhereFilters?.expectedDeliveryDate?.to?.$d,
                  },
                }
              : {}),
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : undefined,
            pincodeIds: finalWhereFilters?.pincodes,
            deliveryPartnerIds: finalWhereFilters?.deliveryPartnerName,
            libraryIds: finalWhereFilters?.name,
            statusTiming: finalWhereFilters?.statusTiming,
            city: finalWhereFilters?.city,
            isPreOrder: finalWhereFilters?.isPreOrder,
            isDelayed: finalWhereFilters?.isDelayed,
            orderTagIds:
              selectedTagIdsRef?.current?.length > 0
                ? selectedTagIdsRef.current
                : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialNewDeliverySort,
        },
      });
    }
    setIsAddCommentLoading(false);
  };

  const handleChallanDownload = async (
    id,
    windowReference,
    orderIds = null,
  ) => {
    setIsChallanLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: true,
    }));
    const response = await getOrderChallanDownloadUrlAdmin({
      variables: {
        where: {
          id,
        },
        ...(orderIds ? { orderIds } : {}),
      },
    });
    if (response?.data) {
      // eslint-disable-next-line no-param-reassign
      windowReference.location =
        response?.data?.getOrderChallanDownloadUrlAdmin?.challanUrl;
    }
    setIsChallanLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: false,
    }));
  };

  const handleChallanReset = async (id) => {
    setIsResetLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: true,
    }));
    await resetOrderChallanAdmin({
      variables: {
        where: {
          id,
        },
      },
    });
    setIsResetLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: false,
    }));
  };

  const handleStickerDownload = async (id, windowReference) => {
    setIsStickerLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: true,
    }));
    const response = await getOrderStickerDownloadUrlAdmin({
      variables: {
        where: {
          id,
        },
      },
    });
    if (response?.data) {
      // eslint-disable-next-line no-param-reassign
      windowReference.location =
        response?.data?.getOrderStickerDownloadUrlAdmin?.stickerUrl;
    }
    setIsStickerLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: false,
    }));
  };

  const handleStickerReset = async (id) => {
    setIsResetStickerLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: true,
    }));
    await resetOrderItemStickerAdmin({
      variables: {
        where: {
          id,
        },
      },
    });
    setIsResetStickerLoading((prevLoadingState) => ({
      ...prevLoadingState,
      [id]: false,
    }));
  };

  const getFilterData = (confirm) => {
    setIsOrderLoading(true);
    setNestedData({});
    setExpandedRowKeys([]);
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          search: orderSearchTerm,
          orderType: ORDER_TYPE?.ALL,
          deliveryType: whereFilter?.deliveryType,
          orderTypes:
            whereFilter?.orderTypes?.length > 0
              ? whereFilter?.orderTypes
              : undefined,
          orderIds: whereFilter?.orderNumber,
          dateRange: {
            from: whereFilter?.createdAt?.from?.$d,
            to: whereFilter?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: whereFilter?.deliveredOn?.from?.$d,
            to: whereFilter?.deliveredOn?.to?.$d,
          },
          ...(whereFilter?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from: whereFilter?.expectedDeliveryDate?.from?.$d,
                  to: whereFilter?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          status:
            whereFilter?.status?.length > 0 ? whereFilter?.status : undefined,
          pincodeIds: whereFilter?.pincodes,
          deliveryPartnerIds: whereFilter?.deliveryPartnerName,
          libraryIds: whereFilter?.name,
          statusTiming: finalWhereFilters?.statusTiming,
          city: whereFilter?.city,
          isPreOrder: finalWhereFilters?.isPreOrder,
          isDelayed: finalWhereFilters?.isDelayed,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFilter });
    finalWhereFiltersRef.current = {
      ...finalWhereFiltersRef.current,
      ...whereFilter,
    };
    setExportFilter({ ...exportFilter, ...finalWhereFilters, ...whereFilter });
    setFinalFilterTags(filterTags);
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      skip: 0,
      current: 1,
    };

    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      filters: { ...finalWhereFilters, ...whereFilter },
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
    });
    if (confirm) {
      confirm();
    }
  };

  const handleReset = (clearFilters, dataIndex, confirm) => {
    const tagsCopy = {
      ...filterTags,
      [dataIndex]: [],
    };
    let whereFiltersCopy;
    if (dataIndex === 'deliveryType') {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: null,
      };
    } else {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: [],
      };
    }
    setFilterVisible(false);
    setFinalFilterTags({ ...filterTags, ...tagsCopy });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFiltersCopy });
    finalWhereFiltersRef.current = {
      ...finalWhereFiltersRef.current,
      ...whereFiltersCopy,
    };
    setExportFilter({
      ...exportFilter,
      ...finalWhereFilters,
      ...whereFiltersCopy,
    });
    setIsOrderLoading(true);
    setNestedData({});
    setExpandedRowKeys([]);
    ordersAdmin({
      variables: {
        filter: {
          ...initialNewDeliveryFilter,
          search: orderSearchTerm,
          limit: paginationProp?.pageSize || LIMIT,
          orderType: ORDER_TYPE?.ALL,
          orderIds: whereFiltersCopy?.orderNumber,
          deliveryType: whereFiltersCopy?.deliveryType,
          orderTypes:
            whereFiltersCopy?.orderTypes?.length > 0
              ? whereFiltersCopy?.orderTypes
              : undefined,
          dateRange: {
            from: whereFiltersCopy?.createdAt?.from?.$d,
            to: whereFiltersCopy?.createdAt?.to?.$d,
          },
          deliveredOn: {
            from: whereFiltersCopy?.deliveredOn?.from?.$d,
            to: whereFiltersCopy?.deliveredOn?.to?.$d,
          },
          ...(whereFiltersCopy?.expectedDeliveryDate?.from
            ? {
                expectedDeliveryDate: {
                  from: whereFiltersCopy?.expectedDeliveryDate?.from?.$d,
                  to: whereFiltersCopy?.expectedDeliveryDate?.to?.$d,
                },
              }
            : {}),
          status:
            whereFiltersCopy?.status?.length > 0
              ? whereFiltersCopy?.status
              : undefined,
          pincodeIds: whereFiltersCopy?.pincodes,
          deliveryPartnerIds: whereFiltersCopy?.deliveryPartnerName,
          libraryIds: whereFiltersCopy?.name,
          statusTiming: finalWhereFilters?.statusTiming,
          city: whereFiltersCopy?.city,
          isPreOrder: finalWhereFilters?.isPreOrder,
          isDelayed: finalWhereFilters?.isDelayed,
          orderTagIds:
            selectedTagIdsRef?.current?.length > 0
              ? selectedTagIdsRef.current
              : undefined,
        },
        sort: sortedInfo?.column
          ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
          : initialNewDeliverySort,
      },
    });
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    paginationPropRef.current = {
      ...paginationPropRef?.current,
      skip: 0,
      current: 1,
    };
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      filters: { ...finalWhereFilters, ...whereFiltersCopy },
      paginationProp: { ...paginationProp, current: 1, skip: 0 },
      filterTags: { ...filterTags, ...tagsCopy },
    });
    clearFilters();
    setFilterVisible(false);
    if (confirm) {
      confirm();
    }
  };

  useEffect(() => {
    if (filterVisible) {
      setFilterList([]);
      setFilterLoading(true);
      setIsEmptyFilterList(false);

      setFilterTags({ ...filterTags, ...finalFilterTags });
      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
        filterTags: { ...filterTags, ...finalFilterTags },
      });
      setWhereFilter({ ...whereFilter, ...finalWhereFilters });
      setFilterIsEnd(false);
      const optionsCopy = [];

      switch (filterIndex) {
        case 'deliveryPartnerName':
          users({
            variables: {
              filter: {
                ...initialTableFilter,
                roles: [USER_ROLES?.DELIVERY?.key],
              },
              sort: initialTableSort,
            },
          });
          break;

        case 'pincodes':
          pincodes({
            variables: {
              filter: {
                ...initialTableFilter,
              },
              sort: {
                field: 'pincode',
                order: 'ASC',
              },
            },
          });
          break;

        case 'orderTypes':
          forEach(ORDER_TYPE_FILTER_OPTIONS, (item) => {
            optionsCopy?.push({ label: item?.label, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'deliveryType':
          forEach(DELIVERY_TYPE_OPTIONS, (item) => {
            optionsCopy?.push({ label: item?.label, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'status':
          forEach(ORDER_STATUS, (item) => {
            optionsCopy?.push({ label: item?.text, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'orderNumber':
          orderSelect({
            variables: {
              filter: { ...initialTableFilter, orderType: ORDER_TYPE?.ALL },
              sort: initialTableSort,
            },
          });
          break;

        case 'name':
          libraries({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        case 'city':
          cities({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        default:
          break;
      }
    }
    if (!filterVisible) {
      setFilterTags(finalFilterTags);
      saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
        filterTags: finalFilterTags,
      });
      setWhereFilter(finalWhereFilters);
      setFilterSearch('');
    }
  }, [filterVisible]);

  const onFilterScroll = (event, dataIndex) => {
    if (dataIndex === 'status' || dataIndex === 'orderTypes') {
      return;
    }
    if (filterScrollDebounceJob) {
      filterScrollDebounceJob?.cancel();
      filterScrollDebounceJob = null;
    }
    if (
      !isUsersLoading &&
      !isPincodesLoading &&
      !isOrderSelectLoading &&
      !isLibrariesLoading &&
      !isCityLoading &&
      !filterIsEnd
    ) {
      const target = event?.target;
      const currentLength = filterList?.length;
      if (
        target?.scrollTop + target?.offsetHeight >=
        target?.scrollHeight - 5
      ) {
        filterScrollDebounceJob = debounce(() => {
          setFilterLoading(true);
          switch (dataIndex) {
            case 'deliveryPartnerName':
              users({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                    roles: [USER_ROLES?.DELIVERY?.key],
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'pincodes':
              pincodes({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: {
                    field: 'pincode',
                    order: 'ASC',
                  },
                },
              });
              break;

            case 'orderNumber':
              orderSelect({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                    orderType: ORDER_TYPE?.ALL,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'name':
              libraries({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'city':
              cities({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;
            default:
              break;
          }
        }, 500);
        filterScrollDebounceJob();
      }
    }
  };

  const handleFilterSearch = (value, dataIndex) => {
    setFilterSearch(value);
    setFilterIsEnd(false);
    setFilterLoading(true);
    setFilterList([]);
    switch (dataIndex) {
      case 'deliveryPartnerName':
        users({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
              roles: [USER_ROLES?.DELIVERY?.key],
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'pincodes':
        pincodes({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: {
              field: 'pincode',
              order: 'ASC',
            },
          },
        });
        break;

      case 'orderNumber':
        orderSelect({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
              orderType: ORDER_TYPE?.ALL,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'name':
        libraries({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'city':
        cities({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      default:
        break;
    }
  };

  const changeFilter = (newFilterObj, dataIndex) => {
    const {
      target: { value },
    } = newFilterObj;

    const filterTagsCopy = { ...filterTags };
    let newTagList;
    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filter(filterTagsCopy?.[dataIndex], (item) => {
          if (item?.label) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    } else {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filterTagsCopy?.[dataIndex]
          ? [...filterTagsCopy?.[dataIndex], value]
          : [value],
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      filterTags: newTagList,
    });
  };

  const handleDeleteFilter = (value, dataIndex) => {
    let newTagList;

    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTags,
        [dataIndex]: filter(filterTags?.[dataIndex], (item) => {
          if (item?.key) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
    saveRetainedFilterState(TABLE_FILTER_KEYS.ALL_DELIVERY, {
      filterTags: newTagList,
    });
  };

  const onRangePickerChange = (values, dataIndex) => {
    const rangeObj = {
      from: values[0]?.startOf('day'),
      to: values?.[1]?.endOf('day'),
    };

    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: rangeObj,
    };
    if (!values?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const onRadioChange = (value, dataIndex) => {
    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: value,
    };
    if (!value?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const filterPopup = (dataIndex, showSearch = true) => ({
    filterDropdown: ({ confirm, clearFilters }) => {
      if (
        dataIndex === 'createdAt' ||
        dataIndex === 'deliveredOn' ||
        dataIndex === 'expectedDeliveryDate'
      ) {
        return (
          <div className="custom-filter-dropdown">
            <RangePicker
              allowClear={false}
              format={DATE_FORMATS?.REGULAR}
              onChange={(values) => onRangePickerChange(values, dataIndex)}
              value={
                whereFilter?.[dataIndex]?.from
                  ? [
                      whereFilter?.[dataIndex]?.from,
                      whereFilter?.[dataIndex]?.to,
                    ]
                  : null
              }
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      if (dataIndex === 'deliveryType') {
        return (
          <div className="custom-filter-dropdown">
            <Group
              options={DELIVERY_TYPE_OPTIONS}
              value={whereFilter?.[dataIndex]}
              onChange={(e) => onRadioChange(e?.target?.value, dataIndex)}
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      return (
        <div className="custom-filter-dropdown">
          <LoaderComponent
            spinning={filterLoading}
            setHeight={35}
            size="medium"
          >
            {showSearch && (
              <SearchComponent
                className="filter-search"
                id="search-container-id-roles"
                placeholder="Search..."
                name={dataIndex}
                query={filterSearch}
                setQuery={setFilterSearch}
                getData={(value) => handleFilterSearch(value, dataIndex)}
              />
            )}
            {filterTags?.[dataIndex]?.length > 0 && (
              <div className="filter-tags-wrapper">
                {map(filterTags?.[dataIndex], (item) => (
                  <Tag
                    key={item?.key}
                    closable
                    onClose={() => handleDeleteFilter(item, dataIndex)}
                    className="filter-tag"
                  >
                    <span>{item?.label}</span>
                  </Tag>
                ))}
              </div>
            )}
            <div
              className="filter-checkboxes"
              onScroll={(e) => onFilterScroll(e, dataIndex)}
            >
              {filterList?.length > 0
                ? map(filterList, (item) => (
                    <div className="single-checkbox-div" key={item?.key}>
                      <Checkbox
                        value={item}
                        checked={whereFilter?.[dataIndex]?.includes(item?.key)}
                        key={item?.key || item}
                        onChange={(e) => changeFilter(e, dataIndex)}
                        className="single-checkbox"
                      >
                        <span>{item?.label}</span>
                      </Checkbox>
                    </div>
                  ))
                : isEmptyFilterList && (
                    <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
                  )}
            </div>
          </LoaderComponent>
          <Divider className="divider-filter" />
          <div className="d-flex justify-center">
            <Button
              size="small"
              className="reset-button"
              id="roles-filter-reset"
              onClick={() => handleReset(clearFilters, dataIndex, confirm)}
            >
              Reset
            </Button>
            <Button
              size="small"
              className="common-button ok-button"
              id="roles-filter-ok"
              type="primary"
              onClick={() => getFilterData(confirm, dataIndex)}
            >
              Ok
            </Button>
          </div>
        </div>
      );
    },
    filterIcon: () =>
      finalWhereFilters?.[dataIndex]?.length > 0 ||
      !isEmpty(finalWhereFilters?.[dataIndex]) ? (
        <FilterFilled className="filter-icon filter-filled" />
      ) : (
        <FilterOutlined className="filter-icon" />
      ),
    onFilterDropdownOpenChange: (isVisible) => {
      setFilterIndex(dataIndex);
      setFilterVisible(isVisible);
    },
  });

  const handleExpand = async (expanded, record) => {
    setIsLoading({
      [record?.id]: true,
    });
    setIsDisabled(true);
    if (!nestedData?.[record?.id]) {
      const res = await orderItemsAdmin({
        variables: {
          where: {
            id: record?.id,
          },
        },
      });
      if (res?.data) {
        setNestedData((state) => ({
          ...state,
          [record?.id]: res?.data,
        }));
      }
      setIsDisabled(false);
    }
    if (expanded) {
      setExpandedRowKeys([...expandedRowKeys, record?.id]);
    } else {
      setExpandedRowKeys(expandedRowKeys?.filter((key) => key !== record?.id));
    }
    setIsLoading({
      [record?.id]: false,
    });
    setIsDisabled(false);
  };

  const columns = [
    {
      title: 'ORDER ID',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'left',
      ellipsis: true,
      fixed: 'left',
      className: 'max-width-column',
      sorter: true,
      width: 150,
      sortOrder: sortedInfo?.columnKey === 'createdAt' && sortedInfo?.order,
      render: (_, record) => (
        <div className="d-flex align-center">
          <RenderCopyIcon copyText={record?.orderNumber} />
          {record?.orderNumber || '-'}
          <>
            {record?.isExpressDelivery && !record?.isQuickDelivery && (
              <Tooltip
                title={EXPRESS_DELIVERY_TOOLTIP_TEXT}
                placement="top"
                zIndex={4}
              >
                <Tag color="red" className="ml-8 mr-0 express-delivery-icon">
                  {EXPRESS_DELIVERY_EMOJI}
                </Tag>
              </Tooltip>
            )}
            {record?.isQuickDelivery && (
              <Tooltip
                title={QUICK_DELIVERY_TOOLTIP_TEXT}
                placement="top"
                zIndex={4}
              >
                <Tag color="yellow" className="ml-8 mr-0 quick-delivery-icon">
                  {QUICK_DELIVERY_EMOJI}
                </Tag>
              </Tooltip>
            )}
          </>
          {record?.isFirstOrder && (
            <StatusFlag type={ORDER_TAG_TYPES.FIRST_ORDER} />
          )}
          {(record?.delayedInConfirmed || record?.delayedInShipped) && (
            <StatusFlag
              type={
                record?.delayedInShipped
                  ? ORDER_TAG_TYPES.DELAYED_SHIPMENT
                  : ORDER_TAG_TYPES.DELAYED_CONFIRMED
              }
            />
          )}
          {record?.metadata?.isContainBigToy && <BigToyIcon />}
          {hasPreOrderToy(record) && (
            <StatusFlag type={ORDER_TAG_TYPES.PRE_ORDER} />
          )}
          <OrderDynamicTags tags={record?.orderTags} />
        </div>
      ),
      ...filterPopup('orderNumber'),
    },
    {
      title: 'ADLOGGS ORDER ID',
      dataIndex: 'partnerOrderId',
      key: 'partnerOrderId',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 160,
      render: (_, record) => (
        <div className="d-flex align-center">
          <RenderCopyIcon
            copyText={record?.partnerOrderId}
            toolTipText="Copy Adloggs Order ID"
          />
          {record?.partnerOrderId || 'Not yet sent to Adloggs'}
        </div>
      ),
    },
    {
      title: 'QUANTITY',
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      align: 'left',
      width: 100,
      className: 'max-width-column',
      render: (_, record) => record?.orderItemCount || '-',
    },
    {
      title: 'TOTAL ORDERS COUNT',
      dataIndex: 'totalOrdersCount',
      key: 'totalOrdersCount',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === 'totalOrdersCount' && sortedInfo?.order,
      render: (_, record) => record?.totalOrdersCount ?? '-',
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => (
        <Badge
          color={ORDER_STATUS?.[record?.status]?.color}
          text={ORDER_STATUS?.[record?.status]?.text}
        />
      ),
      ...filterPopup('status', false),
    },
    {
      title: 'ORDER TYPE',
      dataIndex: 'orderType',
      key: 'orderType',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) => record?.orderType || '-',
      ...filterPopup('orderTypes', false),
    },
    {
      title: 'ORDER SLA',
      dataIndex: 'orderPackagingSLA',
      key: 'orderPackagingSLA',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        record?.nextStatusTime &&
        record?.status !== ORDER_STATUS.DELIVERED.value &&
        record?.status !== ORDER_STATUS.CANCELLED.value
          ? formatDate(record?.nextStatusTime, DATE_FORMATS?.WITH_TIME)
          : 'N/A',
    },
    {
      title: 'ORDER TIME LEFT',
      dataIndex: 'timeLeft',
      key: 'timeLeft',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) => {
        const nextStatusTime = new Date(record.nextStatusTime)?.getTime();
        return (
          <div>
            {!isEmpty(record?.nextStatusTime) &&
            record?.status !== ORDER_STATUS.DELIVERED.value &&
            record?.status !== ORDER_STATUS.CANCELLED.value ? (
              <Countdown date={nextStatusTime} renderer={renderer} />
            ) : (
              'N/A'
            )}
          </div>
        );
      },
    },
    {
      title: 'DELIVERY TYPE',
      dataIndex: 'deliveryType',
      key: 'deliveryType',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) =>
        DELIVERY_TYPE?.[record?.deliveryType]?.label || '-',
      ...filterPopup('deliveryType'),
    },
    {
      title: 'USER NAME',
      dataIndex: 'userName',
      key: 'userName',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: `max-width-column`,
      onCell: (record) => ({
        onClick: (e) =>
          isUserPermission &&
          record?.user?.id &&
          handleOpenUserDrawer(e, record?.user, dispatch),
        className: `${
          isUserPermission && record?.user?.id && 'pointer table-cell'
        }`,
      }),
      render: (_, record) => {
        const userData = record?.user;
        return (
          <>
            {userData?.firstName || userData?.lastName ? (
              <div className="table-data-with-id">{`${
                userData?.firstName ? userData?.firstName : ''
              } ${userData?.lastName ? userData?.lastName : ''}`}</div>
            ) : (
              '-'
            )}
            {userData?.userNumber ? (
              <div className="font-size-12">({userData?.userNumber})</div>
            ) : (
              ''
            )}
          </>
        );
      },
    },
    {
      title: 'LIBRARY NAME',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isLibraryPermission &&
            record?.library?.id &&
            history?.push(
              `${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}${ROUTES?.BASIC_DETAILS}/view/${record?.library?.id}/${record?.library?.libraryNumber}`,
            ),
          className: `${
            isLibraryPermission && record?.library?.id && 'pointer table-cell'
          }`,
        },
      render: (_, record) => (
        <>
          <div className="table-data-with-id">{record?.library?.name}</div>
          <div className="font-size-12">({record?.library?.libraryNumber})</div>
        </>
      ),
      ...filterPopup('name'),
    },
    {
      title: 'CITY',
      dataIndex: 'city',
      key: 'city',
      width: 160,
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      render: (_, record) => (
        <>
          <div>{record?.library?.city || '-'}</div>
        </>
      ),
      ...filterPopup('city'),
    },
    {
      title: 'PINCODE',
      dataIndex: 'pincode',
      key: 'pincode',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) => record?.user?.pincode?.pincode || '-',
      ...filterPopup('pincodes'),
    },
    {
      title: 'DELAY REASON',
      dataIndex: 'delayReason',
      key: 'delayReason',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => (
        <div className="action-button">
          {!isEmpty(record?.metadata?.delayReason) ? (
            <Tooltip title="View reason" placement="top" zIndex={4}>
              <CommentIcon
                className="mr-16 pointer svg-icon"
                onClick={(e) => {
                  e?.stopPropagation();
                  setIsReasonPrompt(true);
                  setOrder(record);
                  setIsOrderAction(true);
                }}
              />
            </Tooltip>
          ) : (
            <span className="mr-24">-</span>
          )}
        </div>
      ),
    },

    {
      title: 'DELIVERY PARTNER NAME',
      dataIndex: 'deliveryPartnerName',
      key: 'deliveryPartnerName',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: `max-width-column`,
      onCell: (record) =>
        !isSalesUser(currentUser) && {
          onClick: () =>
            isDeliveryPartnerPermission &&
            record?.deliveryPartner?.id &&
            history?.push(
              `${ROUTES?.SYSTEM_USERS}${ROUTES?.DELIVERY_PARTNERS}/view/${record?.deliveryPartner?.id}`,
            ),
          className: `${
            isUserPermission &&
            record?.deliveryPartner?.id &&
            'pointer table-cell'
          }`,
        },
      render: (_, record) => {
        const deliveryPartnerData = record?.deliveryPartner;
        const deliveryStaffDetails = record?.metadata?.deliveryStaffDetails;

        const partnerData = deliveryPartnerData || deliveryStaffDetails;

        return (
          <>
            {partnerData?.firstName ||
            partnerData?.lastName ||
            partnerData?.name ? (
              <div className="table-data-with-id">{`${
                partnerData?.firstName || partnerData?.name || ''
              } ${partnerData?.lastName || ''}`}</div>
            ) : (
              '-'
            )}
            {partnerData?.userNumber || partnerData?.phone ? (
              <div className="font-size-12">
                ({partnerData?.userNumber || partnerData?.phone})
              </div>
            ) : (
              ''
            )}
          </>
        );
      },
      ...filterPopup('deliveryPartnerName'),
    },

    {
      title: 'PLACED ON',
      dataIndex: 'placedOn',
      key: 'placedOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.createdAt, DATE_FORMATS?.WITH_TIME),
      ...filterPopup('createdAt'),
    },
    {
      title: 'EXPECTED DELIVERY DATE',
      dataIndex: 'expectedDeliveryDate',
      key: 'expectedDeliveryDate',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === 'expectedDeliveryDate' && sortedInfo?.order,
      render: (_, record) =>
        formatDate(record?.expectedDeliveryDate, DATE_FORMATS?.WITH_TIME) ||
        '-',
      ...filterPopup('expectedDeliveryDate'),
    },
    {
      title: 'DELIVERED ON',
      dataIndex: 'deliveredOn',
      key: 'deliveredOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.deliveredOn, DATE_FORMATS?.WITH_TIME) || '-',
      ...filterPopup('deliveredOn'),
    },
    {
      title: 'SHIPPED ATTACHMENTS',
      dataIndex: 'shippedAttachments',
      key: 'shippedAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const shippedAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            attachment?.deliveryAttachmentsType ===
            ORDER_STATUS?.SHIPPED?.value,
        );

        const hasAttachments = shippedAttachments?.length > 0;
        const additionalCount = shippedAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(shippedAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(shippedAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },
    {
      title: 'DELIVERED ATTACHMENTS',
      dataIndex: 'deliveredAttachments',
      key: 'deliveredAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const deliveredAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            [ORDER_STATUS?.DELIVERED?.value, null]?.includes(
              attachment?.deliveryAttachmentsType,
            ),
        );

        const hasAttachments = deliveredAttachments?.length > 0;
        const additionalCount = deliveredAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(deliveredAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(deliveredAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },

    {
      title: 'NOTE',
      dataIndex: 'note',
      key: 'note',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => (
        <div className="action-button" onClick={(e) => e?.stopPropagation()}>
          {record?.cancellationData ||
          record?.comment?.comment ||
          (record?.status === ORDER_STATUS?.NOT_DELIVERED?.value &&
            record?.metadata?.notDeliveredReason) ? (
            <Tooltip title="View comment" placement="top" zIndex={4}>
              <CommentIcon
                className="mr-16 pointer svg-icon"
                onClick={() => {
                  setIsNotePrompts(true);
                  setOrder(record);
                  setIsOrderAction(true);
                }}
              />
            </Tooltip>
          ) : (
            <span className="mr-24">-</span>
          )}
          {hasUpdatePermission && (
            <Button
              type="primary"
              size="small"
              className="table-action-primary-btn"
              onClick={() => {
                setIsCommentPrompts(true);
                setOrder(record);
                setIsOrderAction(true);
              }}
              disabled={
                record?.comment?.isResolved ||
                record?.status !== ORDER_STATUS?.CANCELLED?.value
              }
            >
              Resolve
            </Button>
          )}
        </div>
      ),
    },
    {
      title: isSalesUser(currentUser) ? 'VIEW STATUS LOGS' : 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      ellipsis: true,
      width: 500,
      align: 'left',
      render: (_, record) => (
        <>
          <div className="action-button" onClick={(e) => e.stopPropagation()}>
            {hasUpdatePermission && !isSalesUser(currentUser) && (
              <div className="mr-16">
                <Button
                  type="primary"
                  size="small"
                  className="table-action-primary-btn"
                  onClick={(e) => {
                    e?.stopPropagation();
                    setIsAddCommentModalOpen(true);
                    setOrder(record);
                    setIsOrderAction(true);
                  }}
                  disabled={
                    record?.status === ORDER_STATUS?.DELIVERED?.value ||
                    record?.status === ORDER_STATUS?.CANCELLED?.value
                  }
                >
                  Cancel
                </Button>
              </div>
            )}

            {!isSalesUser(currentUser) && (
              <div className="mr-16">
                <ChallanDownloadButton
                  order={record}
                  handleChallanDownload={handleChallanDownload}
                  isChallanLoading={isChallanLoading}
                />
              </div>
            )}
            {!isSalesUser(currentUser) && (
              <Button
                type="primary"
                size="small"
                className="table-action-primary-btn"
                onClick={() => handleChallanReset(record?.id)}
                loading={isResetLoading?.[record?.id]}
                disabled={
                  ![
                    ORDER_STATUS?.READY_TO_SHIP?.value,
                    ORDER_STATUS?.CONFIRMED?.value,
                  ]?.includes(record?.status)
                }
              >
                Reset Challan
              </Button>
            )}

            {currentUser?.roles?.includes(USER_ROLES?.SUPER_ADMIN?.key) && (
              <div className="ml-16">
                <Button
                  type="primary"
                  size="small"
                  className="table-action-primary-btn"
                  onClick={(e) => {
                    e?.stopPropagation();
                    setIsDeliveredPrompt(true);
                    setOrder(record);
                  }}
                  disabled={
                    record?.status === ORDER_STATUS?.PLACED?.value ||
                    record?.status === ORDER_STATUS?.CANCELLED?.value ||
                    record?.status === ORDER_STATUS?.DELIVERED?.value ||
                    record?.status === ORDER_STATUS?.PROCESSING?.value ||
                    record?.status === ORDER_STATUS?.AWAITING_PAYMENT?.value
                  }
                >
                  Mark as Delivered
                </Button>
              </div>
            )}
            <Tooltip title="Order Status Logs" placement="top" zIndex={4}>
              <InfoIcon
                onClick={() => {
                  setOrder(record);
                  setIsOrderAction(true);
                  setIsOrderStatusModalOpen(true);
                }}
                className="ml-16 pointer svg-icon"
              />
            </Tooltip>
            {record?.metadata?.adloggsOrderTrackUrl && (
              <Tooltip title="Track Order" placement="top" zIndex={4}>
                <TruckIcon
                  className="ml-16 pointer svg-icon"
                  onClick={() => {
                    setTrackingUrl(record?.metadata?.adloggsOrderTrackUrl);
                    setIsTrackingModalOpen(true);
                  }}
                />
              </Tooltip>
            )}
            {record?.deliveryPartner?.id && !isSalesUser(currentUser) && (
              <Tooltip title="View Location" placement="top" zIndex={4}>
                <LocationIcon
                  onClick={(e) => {
                    e?.stopPropagation();
                    const [lng, lat] = record?.latLong?.coordinates || [];
                    openGoogleMaps(lat, lng, record?.deliveryPartner?.id);
                  }}
                  className="ml-16 mt-4 pointer svg-icon"
                />{' '}
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
    {
      title: 'CLUB ORDER NAME',
      dataIndex: 'clubOrderName',
      key: 'clubOrderName',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 260,
      render: (_, record) => record?.metadata?.clubOrderName || '-',
    },
  ];
  const rowSelection = {
    selectedRowKeys: selectedOrders,
    onChange: (selectedRowKeys) => {
      setSelectedOrders(selectedRowKeys);
    },
    fixed: true,
    preserveSelectedRowKeys: true,
    getCheckboxProps: () => ({
      // Keep selection enabled for bulk tag actions.
      // Any status-based restrictions should be applied to the specific
      // next-action buttons, not to the ability to select rows for tags.
      disabled: false,
    }),
  };
  const expandedRowRender = (data) => {
    const orderItemList = nestedData?.[data?.id]?.orderItemsAdmin?.data;
    const nestedColumns = [
      {
        title: 'ORDER ID',
        dataIndex: 'orderNumber',
        key: 'orderNumber',
        ellipsis: true,
        align: 'left',
        fixed: 'left',
        className: 'max-width-column',
        width: 100,
        render: (_, record) => (
          <div className="d-flex align-center">
            <RenderCopyIcon copyText={record?.order?.orderNumber} />
            {record?.order?.orderNumber || '-'}
          </div>
        ),
      },
      {
        title: 'PRODUCT NAME',
        dataIndex: 'productName',
        key: 'productName',
        ellipsis: true,
        fixed: 'left',
        align: 'left',
        width: 250,
        className: 'max-width-column',
        onCell: (record) =>
          !isSalesUser(currentUser) && {
            onClick: () =>
              isToyPermission &&
              record?.toy?.id &&
              openToyDrawer(record?.toy?.id),
            className: `${
              isToyPermission && record?.toy?.id && 'pointer table-cell'
            }`,
          },
        render: (_, record) => (
          <>
            <div className="table-data-with-id d-flex align-center">
              {record?.toy?.name || '-'}
            </div>
            {record?.toy?.toyNumber && (
              <div className="font-size-12">({record?.toy?.toyNumber})</div>
            )}
          </>
        ),
      },
      {
        title: 'MAPPED UNIT',
        dataIndex: 'inventoryUnits',
        key: 'inventoryUnits',
        width: 200,
        align: 'left',
        className: 'max-width-column',
        onCell: () => ({
          onClick: (e) => e?.stopPropagation(),
        }),
        render: (_, record) => (
          <MappedUnitsCell units={record?.inventoryUnits} />
        ),
      },
      {
        title: 'IMAGES',
        dataIndex: 'images',
        key: 'images',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => {
          const images = record?.toy?.images;
          return (
            <span>
              {images?.length > 0 ? (
                <>
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={getAttachmentSource(images?.[0])}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(images);
                    }}
                    className="pointer"
                  />
                </>
              ) : (
                <span>No Images</span>
              )}
              {images?.length > 1 ? ` + ${images?.length - 1}` : ''}
            </span>
          );
        },
      },
      {
        title: 'BRAND',
        dataIndex: 'brand',
        key: 'brand',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) => record?.toy?.brand?.name || '-',
      },
      {
        title: 'STATUS',
        dataIndex: 'status',
        key: 'status',
        ellipsis: true,
        width: 180,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => {
          const config =
            FULFILLMENT_STATUS?.[record?.status] ||
            ORDER_STATUS?.[record?.status];
          if (!record?.status) return '-';
          return (
            <Badge
              color={config?.color}
              text={config?.text || humanizeEnum(record?.status)}
            />
          );
        },
      },
      {
        title: 'STOCK AT BOOKING',
        dataIndex: 'stockAtBooking',
        key: 'stockAtBooking',
        align: 'left',
        width: 150,
        render: (_, record) => record?.stockAtBooking ?? '-',
      },
      {
        title: (
          <ColumnTitleWithInfo
            title="AVAILABLE FOR BOOKING"
            info={STOCK_COLUMN_TOOLTIPS.AVAILABLE_FOR_BOOKING}
          />
        ),
        dataIndex: 'availableStock',
        key: 'availableStock',
        align: 'left',
        width: 220,
        render: (_, record) => record?.libraryInventory?.availableStock ?? '-',
      },
      {
        title: (
          <ColumnTitleWithInfo
            title="PHYSICALLY AVAILABLE STOCK"
            info={STOCK_COLUMN_TOOLTIPS.PHYSICALLY_AVAILABLE_STOCK}
          />
        ),
        dataIndex: 'physicallyAvailableStock',
        key: 'physicallyAvailableStock',
        align: 'left',
        ellipsis: true,
        className: 'max-width-column',
        width: 260,
        render: (_, record) =>
          record?.libraryInventory?.physicallyAvailableStock ?? '-',
      },
      {
        title: (
          <ColumnTitleWithInfo
            title="BLOCKED UNITS"
            info={STOCK_COLUMN_TOOLTIPS.BLOCKED_UNITS}
          />
        ),
        dataIndex: 'pendingDispatchCount',
        key: 'pendingDispatchCount',
        align: 'left',
        ellipsis: true,
        className: 'max-width-column',
        width: 260,
        render: (_, record) =>
          record?.libraryInventory?.pendingDispatchCount ?? '-',
      },
      {
        title: 'PACKAGING MATERIAL',
        dataIndex: 'packagingMaterial',
        key: 'packagingMaterial',
        ellipsis: true,
        width: 250,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <>
            {record?.toy?.bag ? (
              <div>
                <span className="mr-8">
                  {record?.toy?.bag?.name} ({record?.toy?.bag?.size})
                </span>
                <Image
                  preview={{ visible: false }}
                  width={22}
                  src={record?.toy?.bag?.image}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setPreviewVisible(true);
                    setToyPreviewImage(record?.toy?.bag?.image);
                  }}
                  className="pointer"
                />
              </div>
            ) : (
              '-'
            )}
          </>
        ),
      },
      {
        title: 'AGE GROUPS',
        dataIndex: 'ageGroups',
        key: 'ageGroups',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) =>
          record?.toy?.ageGroups?.map((ageGroup) =>
            ageGroup?.minAge > 18 ? (
              <Tag key={ageGroup?.id}>
                {Math.floor(ageGroup?.minAge / 12)} -{' '}
                {Math.floor(ageGroup?.maxAge / 12)} Years
              </Tag>
            ) : (
              <Tag key={ageGroup?.id}>
                {ageGroup?.minAge} - {ageGroup?.maxAge} Months
              </Tag>
            ),
          ),
      },
      {
        title: 'FULFILLMENT STATUS',
        dataIndex: 'fulfillmentStatus',
        key: 'fulfillmentStatus',
        ellipsis: true,
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) =>
          record?.status === FULFILLMENT_STATUS?.FULFILLED?.value ||
          record?.status === FULFILLMENT_STATUS?.UNFULFILLED?.value ||
          record?.status === FULFILLMENT_STATUS?.CANCELLED?.value ? (
            <Badge
              color={FULFILLMENT_STATUS?.[record?.status]?.color}
              text={FULFILLMENT_STATUS?.[record?.status]?.text}
            />
          ) : (
            '-'
          ),
      },
      {
        title: 'EXPECTED RETURN',
        dataIndex: 'returnDate',
        key: 'returnDate',
        ellipsis: true,
        align: 'left',
        width: 200,
        className: 'max-width-column',
        render: (_, record) =>
          formatDate(record?.returnDate, DATE_FORMATS?.REGULAR) || '-',
      },
      {
        title: 'DELIVERY CONFIRMATION TYPE',
        dataIndex: 'deliveryConfirmationType',
        key: 'deliveryConfirmationType',
        ellipsis: true,
        align: 'left',
        width: 200,
        className: 'max-width-column',
        render: (_, record) =>
          DELIVERY_CONFIRMATION_TYPE?.[record?.deliveryConfirmationData?.type]
            ?.label || '-',
      },
      {
        title: 'DELIVERY CONFIRMED ON',
        dataIndex: 'confirmedOn',
        key: 'confirmedOn',
        ellipsis: true,
        align: 'left',
        width: 200,
        className: 'max-width-column',
        render: (_, record) =>
          formatDate(
            record?.deliveryConfirmationData?.confirmedAt,
            DATE_FORMATS?.REGULAR,
          ) || '-',
      },
      {
        title: 'NOTE',
        dataIndex: 'note',
        key: 'note',
        ellipsis: true,
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) => (
          <div className="action-button">
            {record?.cancellationData || record?.comment?.comment ? (
              <Tooltip title="View comment" placement="top" zIndex={4}>
                <CommentIcon
                  className="mr-24 pointer svg-icon"
                  onClick={() => {
                    setIsNotePrompts(true);
                    setOrderItem(record);
                    setIsOrderAction(false);
                  }}
                />
              </Tooltip>
            ) : (
              <span className="mr-24">-</span>
            )}
            {hasUpdatePermission && (
              <Button
                type="primary"
                size="small"
                className="table-action-primary-btn"
                onClick={() => {
                  setIsCommentPrompts(true);
                  setOrderItem(record);
                  setIsOrderAction(false);
                }}
                disabled={
                  record?.comment?.isResolved ||
                  record?.status !== FULFILLMENT_STATUS?.UNFULFILLED?.value
                }
              >
                Resolve
              </Button>
            )}
          </div>
        ),
      },
      ...getStaffColumns(
        () => data?.library?.id,
        !isUnitsFeatureEnabledForLibrary(data?.library?.id),
      ),
      {
        title: isSalesUser(currentUser) ? 'VIEW STATUS LOGS' : 'ACTIONS',
        dataIndex: 'actions',
        key: 'actions',
        ellipsis: true,
        width: 400,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <>
            <div className="action-button">
              {!isSalesUser(currentUser) && (
                <>
                  <div className="mr-16">
                    <Button
                      type="primary"
                      size="small"
                      className="table-action-primary-btn"
                      onClick={() => {
                        // eslint-disable-next-line no-undef
                        const windowReference = window.open();
                        handleStickerDownload(record?.id, windowReference);
                      }}
                      loading={isStickerLoading?.[record?.id]}
                      disabled={
                        record?.status ===
                          FULFILLMENT_STATUS?.UNFULFILLED?.value ||
                        ![
                          ORDER_STATUS?.CONFIRMED?.value,
                          ORDER_STATUS?.READY_TO_SHIP?.value,
                        ]?.includes(data?.status)
                      }
                    >
                      Download Sticker
                    </Button>
                  </div>
                  <div className="mr-16">
                    <Button
                      type="primary"
                      size="small"
                      className="table-action-primary-btn"
                      onClick={() => handleStickerReset(record?.id)}
                      loading={isResetStickerLoading?.[record?.id]}
                      disabled={
                        record?.status ===
                          FULFILLMENT_STATUS?.UNFULFILLED?.value ||
                        ![
                          ORDER_STATUS?.CONFIRMED?.value,
                          ORDER_STATUS?.READY_TO_SHIP?.value,
                        ]?.includes(data?.status)
                      }
                    >
                      Reset Sticker
                    </Button>
                  </div>
                  <Button
                    type="primary"
                    size="small"
                    className="table-action-primary-btn"
                    onClick={() => {
                      setOrderItem(record);
                      setIsOrderAction(false);
                      setIsContentMasterModalOpen(true);
                    }}
                  >
                    View Content Logs
                  </Button>
                </>
              )}
              <Tooltip
                title="Order Item Status Logs"
                placement="top"
                zIndex={4}
              >
                <InfoIcon
                  onClick={() => {
                    setOrderItem(record);
                    setIsOrderAction(false);
                    setIsOrderStatusModalOpen(true);
                  }}
                  className="ml-16 pointer svg-icon"
                />
              </Tooltip>
            </div>
          </>
        ),
      },
    ]?.filter((item) => !item?.hidden);

    return (
      <CommonTable
        loading={isLoading[data?.id]}
        columns={nestedColumns}
        dataSource={orderItemList || []}
        pagination={false}
        rowKey={(record) => record?.id}
        className="nested-table colored-nested-table"
      />
    );
  };
  const locale = {
    emptyText: isEmptyOrderList ? '' : <span />,
  };

  const selectedOrdersUniqueTags = useMemo(() => {
    const selected = (selectedOrders || [])
      .map((id) => (orderList || []).find((o) => o?.id === id))
      .filter(Boolean);

    return Array.from(
      new Map(
        selected
          ?.flatMap((o) => o?.orderTags || [])
          ?.filter((t) => t?.id)
          ?.map((t) => [t?.id, t]),
      ).values(),
    );
  }, [orderList, selectedOrders]);

  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <button
        type="button"
        className="ant-table-row-expand-icon ant-table-row-expand-icon-expanded disabled"
        aria-label="Expand row"
        aria-expanded="false"
        onClick={(e) => onExpand(record, e)}
        disabled={isDisabled}
      />
    ) : (
      <button
        type="button"
        className="ant-table-row-expand-icon ant-table-row-expand-icon-collapsed"
        aria-label="Collapse row"
        aria-expanded="true"
        onClick={(e) => onExpand(record, e)}
        disabled={isDisabled}
      />
    );

  const handleCancel = () => {
    setIsContentMasterModalOpen(false);
    setOrderItem({});
  };

  return (
    <>
      <ContentMasterModal
        isModalOpen={isContentMasterModalOpen}
        contentHistory={orderItem?.contentHistory}
        handleCancel={handleCancel}
      />
      <ItemStatusModal
        title={isOrderAction ? 'Order Status Logs' : 'Order Item Status Logs'}
        isModalOpen={isOrderStatusModalOpen}
        setIsModalOpen={setIsOrderStatusModalOpen}
        statusHistories={
          isOrderAction ? order?.statusHistory : orderItem?.statusHistory
        }
        isOrderAction={isOrderAction}
      />
      <ResolveCommentModal
        form={form}
        isResolved={false}
        isModalOpen={isCommentPrompts}
        setIsModalOpen={setIsCommentPrompts}
        isBtnLoading={isCommentLoading}
        onFinish={handleAddComment}
      />
      <NoteModal
        note={
          isOrderAction ? order?.cancellationData : orderItem?.cancellationData
        }
        isModalOpen={isNotePrompts}
        setIsModalOpen={setIsNotePrompts}
        isOrderAction={isOrderAction}
        adminNote={
          isOrderAction ? order?.comment?.comment : orderItem?.comment?.comment
        }
        order={order}
      />
      <DelayReasonModal
        note={order?.metadata}
        isModalOpen={isReasonPrompt}
        setIsModalOpen={setIsReasonPrompt}
        isOrderAction={isOrderAction}
        adminNote={
          isOrderAction ? order?.comment?.comment : orderItem?.comment?.comment
        }
      />
      <AddCommentModal
        form={form}
        isOrderAction={isOrderAction}
        isModalOpen={isAddCommentModalOpen}
        setIsModalOpen={setIsAddCommentModalOpen}
        isBtnLoading={isAddCommentLoading}
        onFinish={handleAddCommentInOrder}
      />
      <CommonPreviewTable
        visible={visible}
        setVisible={setVisible}
        images={toyImages}
        setImages={setToyImages}
      />
      <CommonPreview
        visible={previewVisible}
        setVisible={setPreviewVisible}
        image={toyPreviewImage}
        setImage={setToyPreviewImage}
      />
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isDeliveredPrompt}
        onOk={() => {
          handleDeliverOrder([order?.id]);
          setIsDeliveredPrompt(false);
        }}
        onCancel={() => setIsDeliveredPrompt(false)}
        okButtonProps={{ loading: isDeliverLoading }}
      >
        Are you sure you want to mark this order as
        <strong> Delivered </strong> ?
      </Modal>

      <TrackOrderIframeModal
        isTrackingModalOpen={isTrackingModalOpen}
        setIsTrackingModalOpen={setIsTrackingModalOpen}
        trackingUrl={trackingUrl}
      />

      <div className="d-flex justify-end mb-16 flex-wrap">
        {isDesktop && (
          <>
            <ShowPreOrderSwitch
              finalWhereFiltersRef={finalWhereFiltersRef}
              finalWhereFilters={finalWhereFilters}
              setFinalWhereFilters={setFinalWhereFilters}
              setPaginationProp={setPaginationProp}
              paginationPropRef={paginationPropRef}
              setOrderList={setOrderList}
              fetchOrders={fetchOrders}
              paginationProp={paginationProp}
              setIsOrderLoading={setIsOrderLoading}
              tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
              setSortedInfo={setSortedInfo}
              sortedInfoRef={sortedInfoRef}
              sortedInfo={sortedInfo}
            />
            <ShowDelayedOrdersSwitch
              finalWhereFiltersRef={finalWhereFiltersRef}
              finalWhereFilters={finalWhereFilters}
              setFinalWhereFilters={setFinalWhereFilters}
              setPaginationProp={setPaginationProp}
              paginationPropRef={paginationPropRef}
              setOrderList={setOrderList}
              fetchOrders={fetchOrders}
              paginationProp={paginationProp}
              setIsOrderLoading={setIsOrderLoading}
              tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
            />
          </>
        )}
        <BulkActionButton
          selectedItemIds={selectedOrders}
          actions={ORDER_TAG_BULK_ACTIONS}
          scope="SYSTEM_USERS_END_USERS"
          supportsNestedSubmit
          selectedTagsForRemove={selectedOrdersUniqueTags}
          drawerTitle="Order Bulk Actions"
          className="mr-8"
          onSuccess={() => fetchOrders()}
          onClearSelection={() => setSelectedOrders([])}
          tagConfigSubtype="ORDERS"
          useOrderTagsApi
          orderTagTargetField="orders"
        />
        <OrderTagsFilter
          value={selectedTagIds}
          onChange={handleTagFilterChange}
          placeholder="Filter by Tags"
          className="ml-8"
        />
        <SearchComponent
          className="search-box ml-16"
          query={orderSearchTerm}
          setQuery={setOrderSearchTerm}
          orderSearchTermRef={orderSearchTermRef}
          getData={handleSearch}
        />
      </div>

      {!isDesktop && (
        <div className="d-flex justify-end align-center">
          <Checkbox
            indeterminate={
              selectedOrders?.length < findSelectableOrders()?.length &&
              selectedOrders?.length > 0
            }
            checked={
              selectedOrders?.length > 0 &&
              selectedOrders?.length === findSelectableOrders()?.length &&
              !isOrderLoading &&
              !isFetchMoreOrderLoading
            }
            onChange={(e) => {
              handleSelectAllMobile(e?.target?.checked);
            }}
            className="ml-16"
          >
            Select all
          </Checkbox>
          <ShowPreOrderSwitch
            finalWhereFiltersRef={finalWhereFiltersRef}
            finalWhereFilters={finalWhereFilters}
            setFinalWhereFilters={setFinalWhereFilters}
            setPaginationProp={setPaginationProp}
            paginationPropRef={paginationPropRef}
            setOrderList={setOrderList}
            fetchOrders={fetchOrders}
            paginationProp={paginationProp}
            setIsOrderLoading={setIsOrderLoading}
            tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
            setSortedInfo={setSortedInfo}
            sortedInfoRef={sortedInfoRef}
            sortedInfo={sortedInfo}
          />
          <ShowDelayedOrdersSwitch
            finalWhereFiltersRef={finalWhereFiltersRef}
            finalWhereFilters={finalWhereFilters}
            setFinalWhereFilters={setFinalWhereFilters}
            setPaginationProp={setPaginationProp}
            paginationPropRef={paginationPropRef}
            setOrderList={setOrderList}
            fetchOrders={fetchOrders}
            paginationProp={paginationProp}
            setIsOrderLoading={setIsOrderLoading}
            tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
          />
          <Badge dot={hasNonEmptyValueObj(finalWhereFilters)} size="small">
            <FilterIcon
              className="mobile-svg-icon ml-16"
              onClick={() => setIsAllFilterModalOpen(true)}
            />
          </Badge>
          <div className="ml-16 d-flex align-center">
            <SortDropdown
              isOpen={isAllSortPopoverOpen}
              setIsOpen={setIsAllSortPopoverOpen}
              options={map(sort, (item) => item)}
              sortedInfo={sortedInfo}
              setSortedInfo={setSortedInfo}
              sortedInfoRef={sortedInfoRef}
              onFinish={handleSort}
              tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
            />
          </div>
        </div>
      )}
      {isDesktop ? (
        <div className="colored-table">
          <CommonTable
            locale={locale}
            rowClassName={(record) =>
              getRowClassName(
                record,
                thresholdData,
                playNotificationSound,
                criticalOrdersRef,
              )
            }
            columns={columns}
            data={orderList || []}
            loading={isOrderLoading}
            onChange={handleTableChange}
            paginationConfig={paginationProp}
            rowKey={(record) => record?.id}
            expandedRowKeys={expandedRowKeys}
            onExpand={(_, record) => setOrder(record)}
            rowSelection={!isSalesUser(currentUser) && rowSelection}
            onRow={() => ({
              style: { cursor: 'pointer' },
            })}
            expandable={{
              onExpand: (expanded, record) => handleExpand(expanded, record),
              expandedRowRender: (record) => expandedRowRender(record),
              expandIcon,
              expandRowByClick: true,
            }}
          />
        </div>
      ) : (
        <div className="mobile-container-search-action no-scroll-bar">
          <AllFilterOrderModal
            onFinish={handleFilter}
            isModalOpen={isAllFilterModalOpen}
            setIsModalOpen={setIsAllFilterModalOpen}
            finalWhereFilters={finalWhereFilters}
            setFinalWhereFilters={setFinalWhereFilters}
            finalWhereFiltersRef={finalWhereFiltersRef}
            isAdmin
            isNewPath={false}
            tableFilterKey={TABLE_FILTER_KEYS.ALL_DELIVERY}
          />
          <AllOrderItemModal
            order={order}
            setOrder={setOrder}
            isModalOpen={isAllOrderItemModalOpen}
            setIsModalOpen={setIsAllOrderItemModalOpen}
            handleExpand={handleExpand}
            nestedData={nestedData}
            isLoading={isLoading}
            setIsNotePrompts={setIsNotePrompts}
            setOrderItem={setOrderItem}
            setIsOrderAction={setIsOrderAction}
            setIsContentMasterModalOpen={setIsContentMasterModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
            isAdmin
            isNewPath={false}
            setIsOrderStatusModalOpen={setIsOrderStatusModalOpen}
            handleStickerReset={handleStickerReset}
            handleStickerDownload={handleStickerDownload}
            isStickerLoading={isStickerLoading}
            isResetStickerLoading={isResetStickerLoading}
          />
          <AllOrderList
            orderList={orderList}
            infiniteScrollRef={infiniteScrollRef}
            isFetchMoreOrderLoading={isFetchMoreOrderLoading}
            isEmptyOrderList={isEmptyOrderList}
            isOrderLoading={isOrderLoading}
            setOrder={setOrder}
            setIsNotePrompts={setIsNotePrompts}
            setIsOrderAction={setIsOrderAction}
            setIsAllOrderItemModalOpen={setIsAllOrderItemModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
            handleSelectOrders={handleSelectOrders}
            selectedOrders={selectedOrders}
            setIsReasonPrompt={setIsReasonPrompt}
            isAdmin
            isNewPath={false}
            hasUpdatePermission={hasUpdatePermission}
            setIsAddCommentModalOpen={setIsAddCommentModalOpen}
            setIsOrderStatusModalOpen={setIsOrderStatusModalOpen}
            handleChallanDownload={handleChallanDownload}
            handleChallanReset={handleChallanReset}
            isResetLoading={isResetLoading}
            isChallanLoading={isChallanLoading}
            isAllDelivery
            showNote
            setIsCommentPrompts={setIsCommentPrompts}
            openGoogleMaps={openGoogleMaps}
            setIsDeliveredPrompt={setIsDeliveredPrompt}
          />
        </div>
      )}
      <RiderLocationModal
        isLocationModalVisible={isLocationModalVisible}
        setIsLocationModalVisible={setIsLocationModalVisible}
        latitude={latitude}
        longitude={longitude}
      />
    </>
  );
};

export default AllDeliveryTable;
